<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                blendForm: () => import('../forms/BlendForm'),
                facilityForm: () => import('../forms/FacilityForm'),
                productFileForm: () => import('../forms/ProductFileForm'),
                fields: [
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'autocomplete', text: 'Blend', value: 'blendId', rules: [v => !!v || 'Blend is required'], isRequired: true, form: () => import('./BlendForm'), apiMethod: 'Blends', claim: 'Blends' },
                    { type: 'datetime', text: 'Bottled On', value: 'bottledOn', rules: [v => !!v || 'Bottled On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Facility', value: 'facilityId', rules: [v => !!v || 'Facility is required'], isRequired: true, form: () => import('./FacilityForm'), apiMethod: 'Facilities', claim: 'Facilities' },
                    { type: 'text', text: 'Batch Number', value: 'batchNumber', rules: [v => !(v && v.length > 50) || 'Batch Number must be less than 50 characters'], maxLength: 50 },
                    { type: 'text', text: 'Client Name', value: 'clientName', rules: [v => !(v && v.length > 100) || 'Client Name must be less than 100 characters'], maxLength: 100 },
                    { type: 'text', text: 'Product Grade', value: 'productGrade', rules: [v => !(v && v.length > 100) || 'Product Grade must be less than 100 characters'], maxLength: 100 },
                    { type: 'text', text: 'Bottle Size', value: 'bottleSize', rules: [v => !(v && v.length > 50) || 'Bottle Size must be less than 50 characters'], maxLength: 50 },
                    { type: 'number', text: 'Number Of Bottles', value: 'numberOfBottles', rules: [] },
                    { type: 'datetime', text: 'Dispatched Date', value: 'dispatchedDate', rules: [] },
                    { type: 'checkbox', text: 'If product is sold for retail purposes does packed product comply with Food Standards Code for Labelling?', value: 'isCompliantWithFoodStandardsCodeForLabelling', rules: [v => (v !== null && v !== '') || 'Is Compliant With Food Standards Code For Labelling is required'], isRequired: true },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'productId', form: () => import('../forms/ProductFileForm') }
                ],
                apiMethod: 'Products',
                formTitle: 'Product',
            }
        },
    };
</script>
